import type { CampaignSearchCommand, CampaignSearchResponse } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';
import { assertArray, normalizeLimit, normalizeOffset } from './_utils';

export class SearchCampaignsUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(command: CampaignSearchCommand): Promise<CampaignSearchResponse> {
    assertArray(command.params, 'params');

    return this.repository.searchCampaigns({
      ...command,
      limit: normalizeLimit(command.limit, 10, 1000),
      offset: normalizeOffset(command.offset, 0),
    });
  }
}


